import Helpers from "./helpers";

declare var appInsights: any;

export default class Logger {

	public static trackException(exception: Error, additionalMessage?: string, properties?: any) {
		Helpers.deferTask(() => {
			if (!(exception instanceof Error)) {
				return;
			}
			if (exception.message === 'Error' && !additionalMessage) {
				return;
			}
			if (additionalMessage) {
				exception.message = `${additionalMessage}: ${exception.message}`;
			}
			if (typeof appInsights !== "undefined") {
				appInsights.trackException({
					exception: exception,
					properties: properties
				});
			} else {
				console.error(exception, properties);
			}
		});
	}

	public static trackEvent(name: string, event: any) {
		Helpers.deferTask(() => {
			if (typeof appInsights !== "undefined") {
				appInsights.trackEvent({
					name: name,
					properties: event
				});
			}
		});
	}

	public static trackTrace(message: string) {
		Helpers.deferTask(() => {
			if (typeof appInsights !== "undefined") {
				appInsights.trackTrace({ message: message });
			}
		});
	}

}

(<any>window).Logger = Logger;
